import { Component, OnDestroy, OnInit } from '@angular/core'
import { NgIf } from '@angular/common'
import { Subscription } from 'rxjs'
import { MonitoringService } from '../../services/monitoring.service'
import { StateService } from '../../services/state.service'
import { environment } from '../../environments/environment'
import { TranslateModule } from '@ngx-translate/core'
import { EventService } from '../../services/event.service'
import { NetworkService } from '../../services/network.service'
import { NetworkData } from '../../interfaces/network'
import { SystemData } from '../../interfaces/monitoring'
import { RouterService } from '../../services/router.service'
import { CustomerRegisterComponent } from '../../layout/components/customer-register/customer-register.component'
import { DeviceRegisterComponent } from '../../layout/components/device-register/device-register.component'
import { PlatformService } from '../../platforms/platform.service'

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [NgIf, TranslateModule, CustomerRegisterComponent, DeviceRegisterComponent],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription()
  eventSubscription?: Subscription

  systemData!: SystemData
  networkData?: NetworkData

  isRegistered?: boolean
  deviceId?: string
  deviceName?: string
  customerId?: string
  canDownloadAndUpgradeApp?: boolean

  errors: string[] = []

  readonly serverName = environment.serverName
  readonly serverUrl = environment.serverUrl

  constructor(
    private eventService: EventService,
    private monitoringService: MonitoringService,
    private networkService: NetworkService,
    private platformService: PlatformService,
    private routerService: RouterService,
    private stateService: StateService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerEventListener()
    this.systemData = this.monitoringService.getSystemData()
    this.networkData = this.networkService.getNetworkData()
    this.subscriptions.add(
      this.stateService.isRegistered$.subscribe(isRegistered => {
        this.isRegistered = isRegistered
        if (this.isRegistered) {
          this.deviceId = this.stateService.deviceId
          this.deviceName = this.stateService.deviceName
          this.customerId = this.stateService.customerId
        } else {
          this.deviceId = undefined
          this.deviceName = undefined
          this.customerId = undefined
        }
      })
    )
    this.canDownloadAndUpgradeApp = this.platformService.canDownloadAndUpgradeApp()
    this.stateService.checkRegistration()
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe()
    this.eventSubscription?.unsubscribe()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'COL-BLUE':
          this.platformService.adminOpenAppsSettings()
          break
        default:
          break
      }
    })
  }

  restartApp(): void {
    window.location.href = 'index.html'
  }

  reboot(): void {
    this.platformService.reboot()
  }

  clearGuestData(): void {
    this.stateService.clearGuestData()
  }

  resetApp(): void {
    this.stateService.resetApp()
  }

  upgradeApp(): void {
    if (this.stateService.deviceId) {
      this.platformService.downloadAndUpgradeApp(this.stateService.deviceId)
    }
  }

  navigateToTestPage(): void {
    this.routerService.goToTestPage()
  }
}
